import { FC } from 'react';
import s from './collectionCard.module.scss';
import { Button } from '@components/UIKit/Button/Button';
import parse from 'html-react-parser';
import { useTranslation } from '@hooks/useTranslation';
import { useRouter } from 'next/router';
import { LinksEnum } from '@specs/navigation';
import { CdnPath } from '@specs/cdn';
import { OptimizedImage } from '@components/OptimizedImage/OptimizedImage';
type CollectionCardProps = {
  name: string;
  description: string;
  imageId: string;
  id: number;
};
export const CollectionCardSmall: FC<CollectionCardProps> = ({
  id,
  name,
  description,
  imageId
}) => {
  const {
    translate: tr
  } = useTranslation();
  const router = useRouter();
  return <div className={s.collectionCardSmall} data-sentry-component="CollectionCardSmall" data-sentry-source-file="CollectionCardSmall.tsx">
            <OptimizedImage boxClassName={s.collectionCardSmall__image} path={CdnPath.collectionMeta} cdnId={imageId ?? ''} alt={'collection_image'} data-sentry-element="OptimizedImage" data-sentry-source-file="CollectionCardSmall.tsx" />

            <div className={s.collectionCardSmall__info}>

                <h5 className={s.collectionCardSmall__title}>{name}</h5>

                <div className={s.collectionCardSmall__description}>{parse(description)}</div>

                <Button id='explore_collection_button' onClick={async () => {
        await router.push({
          pathname: LinksEnum.EXPLORE_COLLECTION,
          query: {
            slug: id
          }
        });
      }} color='Black' size='large' data-sentry-element="Button" data-sentry-source-file="CollectionCardSmall.tsx">
                    {tr({
          id: 'btn.explore'
        })}
                </Button>
            </div>
        </div>;
};